module.exports = __webpack_public_path__ + "STOKES_EN-8ow.svg";